import { render, staticRenderFns } from "./EditPreferenciaPage.vue?vue&type=template&id=f64cadcc&"
import script from "./EditPreferenciaPage.vue?vue&type=script&lang=js&"
export * from "./EditPreferenciaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports